import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class DatatargetManagement {
  // 表达式与编译报错功能
  static async runConfig(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('api/real_time_monitor/measuring_point/pre_run_py', payload)
    )
    return Callback(err, res)
  }
  // 指标管理列表页
  static async getTargetList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MeasuringPoint?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 指标详情
  static async getTargetInfo(payload) {
    RecordOperation({ type: 'detail' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/real_time_monitor/measuring_point/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 新增指标
  static async addTargetList(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/measuring_point', payload.params)
    )
    return Callback(err, res)
  }
  // 编辑指标
  static async editTargetList(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(
      wizStandardInstance.patch('/api/real_time_monitor/measuring_point', payload.params)
    )
    return Callback(err, res)
  }
  // 删除指标
  static async removeTargetList(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(
      wizStandardInstance.delete(`/api/real_time_monitor/measuring_point?id=${payload.id}`)
    )
    return Callback(err, res)
  }
  // 唯一性校验
  static async requiredSave(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/real_time_monitor/measuring_point/save', payload.params)
    )
    return Callback(err, res)
  }
  // 机组
  static async apiUnit() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/unit')
    )
    return Callback(err, res)
  }
  // 指标类型
  static async apiTarget() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      inwizStandardInstancestance.get('/api/real_time_monitor/measuring_point/target')
    )
    return Callback(err, res)
  }
  // 模块标签
  static async apiModular() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/modular')
    )
    return Callback(err, res)
  }
  // 专业
  static async apiProfessions() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/profession')
    )
    return Callback(err, res)
  }
  // 时间类型
  static async apiTimetype() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/time')
    )
    return Callback(err, res)
  }
  // 计算类型
  static async apiCalculate() {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get('/api/real_time_monitor/measuring_point/calculate')
    )
    return Callback(err, res)
  }
  // 详情里的测点列表
  static async getPointList(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/real_time_monitor/measuring_point?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导出测点实时历史数据
  static async exportPoints(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/real_time_monitor/measuring_point/runtime_export?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 根据所选测点 查询绑定所需要的数据
  static async getPointMessage(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/plant_unit/plant_unit_base_config/?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async saveBind(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/plant_unit/plant_unit_base_config', payload)
    )
    return Callback(err, res)
  }
  static async uploadTarget(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(
      wizStandardInstance.post(`/api/equipment/target_import/${payload.siteId}`, payload.formData)
    )
    return Callback(err, res)
  }
  static async uplorealTimeMonitoradTarget(payload) {
    console.log(payload, '7777777')
    const [err, res] = await To(
      wizStandardInstance.get(`/api/real_time_monitor/measuring_point/pointId/${payload}`)
    )
    return Callback(err, res)
  }
}
